/* assets/slider-a11y.js — v1.0
   Keyboard + screen-reader accessibility for every Flickity / x-ref="slider" carousel.
   Vanilla JS, no dependencies, idempotent, safe to load site-wide.
   Hooks: data-a11y-skip (opt out), data-a11y-label="…" (custom carousel name). */
(function () {
  'use strict';
  if (window.__sliderA11yLoaded) return;
  window.__sliderA11yLoaded = true;

  var CFG = { announce: true, dedupeLinks: true, fixLabels: true, sweepMs: 1200, debounceMs: 600 };
  var FOC  = 'a[href],button,input,select,textarea,[tabindex]';
  var KEEP = '__a11yKeep';   // "never let the theme hide or unfocus me"
  var DROP = '__a11yDrop';   // "intentionally removed from the tab order"
  var MAP  = new WeakMap(), LIST = [], UID = 0;

  /* 1 ---- guards: block ADA.js from re-locking our slides ------------------ */
  var setA = Element.prototype.setAttribute;
  var remA = Element.prototype.removeAttribute;

  Element.prototype.setAttribute = function (n, v) {
    if (this[KEEP] && !this[DROP]) {
      var k = ('' + n).toLowerCase(), s = ('' + v).trim();
      if (k === 'tabindex' && s === '-1') return;
      if (k === 'aria-hidden' && s === 'true') return;
      if (k === 'inert') return;
    }
    return setA.call(this, n, v);
  };
  Element.prototype.removeAttribute = function (n) {
    if (this[KEEP] && !this[DROP] && ('' + n).toLowerCase() === 'tabindex' && this.__a11yTab != null) return;
    return remA.call(this, n);
  };
  try {
    var TD = Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'tabIndex');
    if (TD && TD.set) {
      Object.defineProperty(HTMLElement.prototype, 'tabIndex', {
        configurable: true, enumerable: TD.enumerable, get: TD.get,
        set: function (v) { if (this[KEEP] && !this[DROP] && v < 0) return; TD.set.call(this, v); }
      });
    }
  } catch (e) {}

  function keep(el, tab) {
    el[KEEP] = 1;
    if (tab != null) { el.__a11yTab = tab; setA.call(el, 'tabindex', '' + tab); }
    if (el.getAttribute('aria-hidden') === 'true') remA.call(el, 'aria-hidden');
    if (el.hasAttribute('inert')) remA.call(el, 'inert');
    try { el.inert = false; } catch (e) {}
  }
  function drop(el) {
    el[DROP] = 1;
    setA.call(el, 'tabindex', '-1');
    setA.call(el, 'aria-hidden', 'true');
  }

  /* 2 ---- helpers --------------------------------------------------------- */
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  function reduced() { return !!(RM && RM.matches); }
  function isRTL(el) { return getComputedStyle(el).direction === 'rtl'; }
  function seen(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; }

  function alpine(el) {                       // read the theme's Alpine component state
    for (var n = el; n; n = n.parentElement) {
      if (n._x_dataStack && n._x_dataStack[0]) return n._x_dataStack[0];
    }
    return null;
  }
  function fkOf(track) {                      // theme bundles its own Flickity copy
    try { if (window.Flickity && Flickity.data) { var f = Flickity.data(track); if (f) return f; } } catch (e) {}
    var st = alpine(track);
    return (st && st.flickity && st.flickity.slides) ? st.flickity : null;
  }
  function cellsOf(track) {
    var slider = track.querySelector(':scope > .flickity-viewport > .flickity-slider');
    return [].filter.call((slider || track).children, function (c) {
      return !/^(SCRIPT|STYLE|TEMPLATE)$/.test(c.tagName) && !c.classList.contains('flickity-button');
    });
  }
  function nameOf(track) {
    var host = track.closest('section,[data-section-id],[x-data]') || track.parentElement;
    var lbl = track.getAttribute('data-a11y-label') || (host && host.getAttribute('data-a11y-label'));
    if (lbl) return lbl.trim();
    var h = host && host.querySelector('h1,h2,h3,h4,.h1,.h2,.h3');
    if (h && !track.contains(h) && h.textContent.trim()) return h.textContent.trim().slice(0, 80);
    var a = track.getAttribute('aria-label') || (host && host.getAttribute('aria-label'));
    return a ? a.trim() : 'Carousel';
  }
  function firstFocusable(root) {
    var list = root.querySelectorAll(FOC);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el[DROP] || el.disabled) continue;
      if (el.getAttribute('tabindex') === '-1') continue;
      if (el.closest('[inert]')) continue;
      if (!seen(el)) continue;
      return el;
    }
    return null;
  }
  function srOnly() {
    if (document.getElementById('a11y-carousel-css')) return;
    var s = document.createElement('style');
    s.id = 'a11y-carousel-css';
    s.textContent = '.a11y-sr-only{position:absolute!important;width:1px;height:1px;margin:-1px;' +
                    'padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}' +
                    '[data-a11y-carousel]:focus-visible{outline:2px solid currentColor;outline-offset:2px}';
    document.head.appendChild(s);
  }

  /* 3 ---- markup preparation ---------------------------------------------- */
  function prepCells(S) {
    S.cells = cellsOf(S.track);
    var total = S.cells.length;
    S.cells.forEach(function (c, i) {
      keep(c);                                     // exposed for good — never hidden again
      if (!c.getAttribute('role')) setA.call(c, 'role', 'group');
      setA.call(c, 'aria-roledescription', 'slide');
      if (!c.getAttribute('aria-label')) setA.call(c, 'aria-label', 'Item ' + (i + 1) + ' of ' + total);

      var links = [].slice.call(c.querySelectorAll('a[href]'));
      if (CFG.dedupeLinks && links.length > 1) {
        links.sort(function (a, b) {               // prefer the link that carries the text
          return (b.textContent.trim() ? 1 : 0) - (a.textContent.trim() ? 1 : 0);
        });
        var used = {};
        links.forEach(function (a) {
          var p;
          try { p = new URL(a.href, location.href).pathname; } catch (e) { p = a.getAttribute('href'); }
          if (used[p]) { drop(a); return; }        // same product, different query string
          used[p] = 1;
          keep(a, 0);
          if (CFG.fixLabels && !a.getAttribute('aria-label') && !a.textContent.trim()) {
            var img = a.querySelector('img'), alt = img && (img.getAttribute('alt') || '').trim();
            setA.call(a, 'aria-label', alt || c.getAttribute('aria-label') || 'Item');
          }
        });
      } else {
        links.forEach(function (a) { keep(a, 0); });
      }
      [].forEach.call(c.querySelectorAll('button,input,select,textarea'), function (b) { keep(b, 0); });
    });
  }

  function prepControls(S) {
    var host = S.host || S.track.parentElement;
    if (!host) return;
    [].forEach.call(host.querySelectorAll('button,[role="button"]'), function (b) {
      if (S.track.contains(b)) return;
      var code = (b.getAttribute('@click') || b.getAttribute('x-on:click') || '') + ' ' +
                 (b.className || '') + ' ' + (b.getAttribute('aria-label') || '');
      if (/next|forward|right/i.test(code) && !S.next) S.next = b;
      else if (/prev|previous|back|left/i.test(code) && !S.prev) S.prev = b;
    });
    [[S.prev, 'Previous'], [S.next, 'Next']].forEach(function (p) {
      var b = p[0]; if (!b) return;
      keep(b, 0);
      if (b.tagName === 'BUTTON' && !b.getAttribute('type')) setA.call(b, 'type', 'button');
      if (!b.getAttribute('aria-label')) setA.call(b, 'aria-label', p[1] + ' items, ' + S.name);
      if (S.hintId) setA.call(b, 'aria-controls', S.track.id || '');
      b.__a11yFor = S;
    });
  }

  /* 4 ---- geometry -------------------------------------------------------- */
  function scrollable(S) { return S.track.scrollWidth - S.track.clientWidth > 4; }

  function range(S) {
    var tr = S.track.getBoundingClientRect(), first = -1, last = -1;
    for (var i = 0; i < S.cells.length; i++) {
      var r = S.cells[i].getBoundingClientRect();
      if (r.width === 0) continue;
      if (r.right > tr.left + 2 && r.left < tr.right - 2) { if (first < 0) first = i; last = i; }
    }
    if (first < 0) { first = 0; last = 0; }
    return [first, last];
  }

  /* 5 ---- movement -------------------------------------------------------- */
  function fkFor(S) {                            // lazy: Flickity boots on scroll-into-view
    if (S.fk && S.fk.slides && S.fk.element === S.track) return S.fk;
    S.fk = fkOf(S.track);
    return S.fk;
  }
  function fkLimit(fk) {
    try { return -(fk.slidesWidth - fk.size.innerWidth); } catch (e) { return 0; }
  }

  function jump(S, i) {
    i = Math.max(0, Math.min(S.cells.length - 1, i));
    S.tgt = i; S.tgtAt = Date.now();
    var cell = S.cells[i], fk = fkFor(S);

    if (scrollable(S)) {                          // native overflow scroller
      var max = S.track.scrollWidth - S.track.clientWidth;
      var left = cell.offsetLeft - S.track.offsetLeft;
      left = isRTL(S.track) ? -Math.max(0, Math.min(max, Math.abs(left)))
                            :  Math.max(0, Math.min(max, left));
      try { S.track.scrollTo({ left: left, behavior: reduced() ? 'auto' : 'smooth' }); }
      catch (e) { S.track.scrollLeft = left; }
    } else if (fk) {                              // instant select — animated select gets reset
      try {
        var n = (fk.slides && fk.slides.length) ? fk.slides.length : S.cells.length;
        fk.select(Math.min(i, n - 1), false, true);
        var st = alpine(S.track);
        if (st && 'index' in st) st.index = fk.selectedIndex;
      } catch (e) {}
    } else if (S.next || S.prev) {                // last resort: drive the theme's own arrows
      var r = range(S), d = i - r[0], b = d > 0 ? S.next : S.prev, k = Math.abs(d);
      while (k-- > 0 && b) b.click();
    }
    schedule(S); sync(S);
  }

  function move(S, dir, byPage) {
    var r = range(S), per = Math.max(1, r[1] - r[0] + 1);
    var step = byPage ? per : 1;
    // accumulate rapid presses instead of collapsing them into one step
    var base = (S.tgt != null && S.tgtAt && Date.now() - S.tgtAt < 900) ? S.tgt : r[0];
    jump(S, base + dir * step);
  }

  function cellIndexOf(S, node) {
    for (var i = 0; i < S.cells.length; i++) if (S.cells[i].contains(node)) return i;
    return -1;
  }
  function ensureVisible(S, node) {               // focus must pull its slide into view
    var i = cellIndexOf(S, node);
    if (i < 0) return;
    var r = range(S);
    if (i < r[0] || i > r[1]) jump(S, i);
  }

  /* 6 ---- announcements + state ------------------------------------------- */
  var live = null;
  function liveRegion() {
    if (live && live.isConnected) return live;
    live = document.createElement('div');
    live.id = 'a11y-carousel-live';
    live.className = 'a11y-sr-only';
    setA.call(live, 'aria-live', 'polite');
    setA.call(live, 'aria-atomic', 'true');
    document.body.appendChild(live);
    return live;
  }
  function message(S) {
    var r = range(S), n = S.cells.length;
    var base = r[0] === r[1] ? 'Item ' + (r[0] + 1) + ' of ' + n
                             : 'Items ' + (r[0] + 1) + ' to ' + (r[1] + 1) + ' of ' + n;
    var names = [];
    for (var i = r[0]; i <= r[1] && names.length < 3; i++) {
      var c = S.cells[i];
      if (c.querySelector('a[href]:not([tabindex="-1"])')) { names = []; break; } // links read themselves
      var t = (c.textContent || '').trim().replace(/\s+/g, ' ');
      if (!t) { var im = c.querySelector('img'); t = im ? (im.getAttribute('alt') || '').trim() : ''; }
      if (t) names.push(t.slice(0, 40));
    }
    return base + (names.length ? ': ' + names.join(', ') : '');
  }
  function say(S, msg) {
    if (!CFG.announce || !S.touched || !msg || msg === S.lastMsg) return;
    S.lastMsg = msg;
    var l = liveRegion();
    l.textContent = '';
    setTimeout(function () { l.textContent = msg; }, 30);
  }
  function schedule(S) {                          // debounce so we read the settled position
    clearTimeout(S.timer);
    S.timer = setTimeout(function () { sync(S); say(S, message(S)); }, CFG.debounceMs);
  }
  function sync(S) {
    var r = range(S), atStart, atEnd;
    if (scrollable(S)) {
      var max = S.track.scrollWidth - S.track.clientWidth, x = Math.abs(S.track.scrollLeft);
      atStart = x <= 2; atEnd = x >= max - 2;
    } else {
      atStart = r[0] <= 0; atEnd = r[1] >= S.cells.length - 1;
      var w = S.cells[0] ? S.cells[0].getBoundingClientRect().width : 0;
      if (!w) {                                   // cells not laid out yet: ask Flickity
        var fk = fkFor(S);
        if (fk) { try { atStart = fk.x >= -1; atEnd = fk.x <= fkLimit(fk) + 1; } catch (e) {} }
      }
    }
    if (S.prev) setA.call(S.prev, 'aria-disabled', atStart ? 'true' : 'false');
    if (S.next) setA.call(S.next, 'aria-disabled', atEnd ? 'true' : 'false');
    setA.call(S.track, 'aria-label', S.name + ' carousel, ' + S.cells.length + ' items');
  }

  /* 7 ---- keyboard (window capture: the theme stops propagation) ---------- */
  function onKey(e) {
    if (e.__a11yHandled || e.defaultPrevented || e.altKey || e.metaKey || e.ctrlKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable) return;

    var track = t.closest('[data-a11y-carousel]');
    var S = track && MAP.get(track);
    if (!S) {
      var btn = t.closest('button');
      if (btn && btn.__a11yFor) { S = btn.__a11yFor; track = S.track; } else return;
    }
    if (!S.cells.length) return;

    var fwd = isRTL(track) ? 'ArrowLeft' : 'ArrowRight';
    var back = isRTL(track) ? 'ArrowRight' : 'ArrowLeft';
    var k = e.key, handled = true;
    S.touched = 1;

    if (k === fwd) move(S, 1);
    else if (k === back) move(S, -1);
    else if (k === 'PageDown') move(S, 1, true);
    else if (k === 'PageUp') move(S, -1, true);
    else if (k === 'Home') jump(S, 0);
    else if (k === 'End') jump(S, S.cells.length - 1);
    else if (k === 'Tab' && !e.shiftKey && t === track) {
      var r = range(S), moved = false;           // Tab enters the slide you scrolled to
      for (var i = r[0]; i <= r[1] && !moved; i++) {
        var f = firstFocusable(S.cells[i]);
        if (f) { f.focus(); moved = document.activeElement === f; }
      }
      handled = moved;                            // never trap focus if nothing took it
    } else handled = false;

    if (handled) { e.preventDefault(); e.stopPropagation(); e.__a11yHandled = 1; }
  }
  window.addEventListener('keydown', onKey, true);
  document.addEventListener('keydown', onKey, true);

  /* 8 ---- wiring, scanning, self-healing --------------------------------- */
  function bind(S) {
    if (S.bound) return;
    S.bound = 1;
    S.track.addEventListener('keydown', onKey, true);
    S.track.addEventListener('scroll', function () { S.touched = 1; schedule(S); }, { passive: true });
    S.track.addEventListener('focusin', function (e) { ensureVisible(S, e.target); }, true);
    [S.prev, S.next].forEach(function (b) {
      if (b) b.addEventListener('click', function () { S.touched = 1; schedule(S); });
    });
    var fk = fkFor(S);
    if (fk && fk.on) { try { fk.on('select', function () { schedule(S); }); } catch (e) {} }
  }

  function isCarousel(track) {
    if (track.hasAttribute('data-a11y-skip')) return false;
    if (getComputedStyle(track).flexWrap === 'wrap') return false;   // collection Sort/filter bar
    if (cellsOf(track).length < 2) return false;                     // single-cell mega-menu tracks
    var host = track.closest('section,[x-data]') || track.parentElement;
    var arrows = host && host.querySelector(
      'button[\\@click*="next"],button[x-on\\:click*="next"],.flickity-button.next,[data-slider-next]');
    return !!(fkOf(track) || track.scrollWidth - track.clientWidth > 4 || arrows);
  }

  function enhance(track) {
    var S = MAP.get(track);
    if (S) { refresh(S); return; }
    if (!isCarousel(track)) return;                // re-checked on later scans (Flickity is lazy)

    S = { track: track, host: track.closest('section,[x-data]') || track.parentElement, cells: [], touched: 0 };
    S.name = nameOf(track);
    MAP.set(track, S); LIST.push(S);

    srOnly();
    setA.call(track, 'data-a11y-carousel', '');
    if (!track.id) track.id = 'a11y-carousel-' + (++UID);
    keep(track, 0);
    setA.call(track, 'role', 'group');
    setA.call(track, 'aria-roledescription', 'carousel');

    var hint = document.createElement('div');
    hint.id = 'a11y-hint-' + UID;
    hint.className = 'a11y-sr-only';
    hint.textContent = 'Use the Left and Right arrow keys to scroll this carousel, ' +
                       'Home and End to jump to the first or last item, then press Tab to reach the items.';
    track.parentNode.insertBefore(hint, track);
    setA.call(track, 'aria-describedby', hint.id);
    S.hintId = hint.id;

    prepCells(S); prepControls(S); bind(S); sync(S);
  }

  function refresh(S) {
    if (!S.track.isConnected) return;
    S.name = nameOf(S.track);
    S.fk = null;
    prepCells(S); prepControls(S); bind(S); sync(S);
  }

  function scan() {
    var q = '[x-ref="slider"],.flickity-enabled,[data-slider],[data-a11y-carousel]';
    [].forEach.call(document.querySelectorAll(q), function (n) {
      try { enhance(n); } catch (e) {}
    });
  }

  /* the theme re-renders cards and re-locks them: re-mark anything that slipped */
  function sweep() {
    for (var s = LIST.length - 1; s >= 0; s--) {
      var S = LIST[s];
      if (!S.track.isConnected) { LIST.splice(s, 1); continue; }

      var cs = cellsOf(S.track);
      if (cs.length !== S.cells.length) { refresh(S); continue; }

      var need = false;
      for (var i = 0; i < cs.length && !need; i++) {
        var c = cs[i];
        if (!c[KEEP] || c.getAttribute('aria-hidden') === 'true' || c.hasAttribute('inert')) { need = true; break; }
        var links = c.querySelectorAll('a[href]');
        for (var j = 0; j < links.length; j++) {
          var a = links[j];
          if (a[DROP]) continue;
          if (!a[KEEP] || a.getAttribute('tabindex') === '-1' || a.getAttribute('aria-hidden') === 'true') {
            need = true; break;
          }
        }
      }
      if (need) refresh(S); else sync(S);
    }
  }

  function boot() {
    scan();
    [200, 600, 1200, 2500, 4000].forEach(function (ms) { setTimeout(scan, ms); });
    setInterval(sweep, CFG.sweepMs);

    document.addEventListener('shopify:section:load', function () { setTimeout(scan, 50); });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { LIST.forEach(sync); scan(); }, 250);
    });

    var mt;
    new MutationObserver(function () {
      clearTimeout(mt);
      mt = setTimeout(scan, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.__sliderA11yScan = scan;
  window.__sliderA11ySweep = sweep;
})();

